<template>
  <section id="page-article">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true" :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-dark">
          <h3 @click="editTitle" v-show="!editingTitle">{{ article.title }}</h3>
          <div class="edit-box" v-show="editingTitle">
            <label for="field-title">title:&nbsp;</label>
            <input id="field-title" v-model="article.title" class="article-field" placeholder="Article title:" type="text">
            &nbsp;<b-button :size="'sm'" :variant="'secondary'" @click="saveTitle" v-show="!creatingNew">save</b-button>
          </div>
        </div>

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <div @click="editIntro" class="article-intro" v-html="article.intro" v-show="!editingIntro"></div>
          <div v-show="editingIntro">
            <quill-editor v-model="article.intro" @change="introChange" :options="introEditorOptions"></quill-editor>
            <br><b-button :size="'sm'" :variant="'secondary'" @click="saveIntro" v-show="!creatingNew">save intro</b-button>
          </div>

          <clearfix :wide="true"></clearfix>

          <div @click="editContent" class="article-content" v-html="article.content" v-show="!editingContent"></div>
          <div v-show="editingContent">
            <quill-editor v-model="article.content" @change="contentChange" :options="contentEditorOptions"></quill-editor>
            <br>
            <b-button :size="'sm'" :variant="'secondary'" @click="saveContent" v-show="!creatingNew">save content</b-button>
            <b-button :size="'large'" :variant="'secondary'" @click="saveArticle" v-show="creatingNew">save article</b-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '../utils/Clearfix'
  import config from './Config'
  import { quillEditor } from 'vue-quill-editor'

  Vue.use(VueAxios, axios)

  export default {
    props: {
      articleId: String
    },
    data () {
      return {
        article: {},
        creatingNew: false,
        editingTitle: false,
        editingIntro: false,
        editingContent: false,
        introEditorOptions: {placeholder: 'Insert the article Intro ...'},
        contentEditorOptions: {placeholder: 'Insert the article Content ...'}
      }
    },
    components: {
      Clearfix, quillEditor
    },
    methods: {
      editTitle () {
        if (this.$store.state.auth.admin) { this.editingTitle = true }
      },
      saveTitle () {
        Vue.axios.put(config.urls.article_update_title + this.articleId, { 'data': this.article.title })
        this.editingTitle = false
      },

      editIntro () {
        if (this.$store.state.auth.admin) { this.editingIntro = true }
      },
      introChange ({html}) {
        this.article.intro = html
      },
      saveIntro () {
        Vue.axios.put(config.urls.article_update_intro + this.articleId, { 'data': this.article.intro })
        this.editingIntro = false
      },

      editContent () {
        if (this.$store.state.auth.admin) { this.editingContent = true }
      },
      contentChange ({html}) {
        this.article.content = html
      },
      saveContent () {
        Vue.axios.put(config.urls.article_update_content + this.articleId, { 'data': this.article.content })
        this.editingContent = false
      },

      saveArticle () {
        Vue.axios.post(config.urls.article, this.article)
          .then(() => { this.$router.push('/') })
      }

    },
    created () {
      if (this.articleId === 'create_new') {
        if (!this.$store.state.auth.admin) {
          this.$router.push('/')
        }
        this.creatingNew = true
        this.editingTitle = true
        this.editingIntro = true
        this.editingContent = true
        this.article = {
          title: '',
          intro: '',
          content: ''
        }
      } else {
        Vue.axios.get(config.urls.article + this.articleId)
        .then((response) => {
          this.article = response.data.article
        })
      }
    }
  }
</script>

<style>
  #page-article {
    background: url('../../assets/img/bg/bg_blog.jpg') center fixed no-repeat #b1b1b1;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
  .article-field {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// BlogArticle.vue?102bc320